function avvioSplideSliderInit() {
  const avvioSplideSlider = ".splide";
  let avvioSplideSliderBlock = document.querySelectorAll(avvioSplideSlider);

  const updateHeroFirstVideoSlide = () => {
    const splideSlider = document.querySelectorAll(".avvio-hero .splide");

    splideSlider.forEach((slider) => {
      const isInitialized = slider.classList.contains("is-initialized");
      if (isInitialized) return false;

      // Reset first slide class
      const firstSlide = slider.querySelector(".splide__slide");
      const heroFirstSlideVideo = firstSlide?.querySelector("video");

      if (heroFirstSlideVideo) {
        heroFirstSlideVideo.classList.remove("js-avvio-hls-video");
        heroFirstSlideVideo.classList.add("js-avvio-first-slide-hls-video");
      }
    });
  };

  const addAutoplayToggleButton = (splide) => {
    if (!splide || Object.keys(splide).length === 0 || !splide.root) return false;

    // Create a new button
    const autoplayToggleButton = document.createElement("button");
    autoplayToggleButton.setAttribute("type", "button");
    autoplayToggleButton.classList.add("splide__autoplay-toggle-button");
    const autoplayToggleButtonText = document.createTextNode("Autoplay toggle");
    autoplayToggleButton.appendChild(autoplayToggleButtonText);
    autoplayToggleButton.style.visibility = "hidden";
    autoplayToggleButton.style.position = "absolute";
    autoplayToggleButton.setAttribute("tabindex", "-1");
    splide.root.appendChild(autoplayToggleButton);

    splide.on("autoplay:play", function () {
      autoplayToggleButton.setAttribute("aria-label", "Pause autoplay");
      autoplayToggleButton.textContent = "Pause";
    });

    splide.on("autoplay:pause", function () {
      autoplayToggleButton.setAttribute("aria-label", "Start autoplay");
      autoplayToggleButton.textContent = "Play";
    });

    autoplayToggleButton.addEventListener("click", function () {
      const Autoplay = splide.Components.Autoplay;

      if (Autoplay.isPaused()) {
        Autoplay.play();
      } else {
        Autoplay.pause();
      }
    });
  };

  if (typeof avvioSplideSliderBlock != "undefined" && avvioSplideSliderBlock != null) {
    // Update the Hero Slider First slide Video Class to initialize video with the Splide slider
    updateHeroFirstVideoSlide();

    for (var i = 0; i < avvioSplideSliderBlock.length; i++) {
      const splideElement = avvioSplideSliderBlock[i];
      const firstSlide = splideElement.querySelector(".splide__slide");
      const heroFirstSlideVideo = firstSlide?.closest(".avvio-hero")?.querySelector("video");

      // State
      let hasAutoplay = false;
      let splide = {};
      let autoplay = {};
      let isAutoplayResumed = false;

      function initSlider(hasFirstVideoSlide) {
        let pagination = splideElement.querySelector(".splide__pagination");
        if (typeof pagination != "undefined" && pagination != null) {
          pagination.remove();
        }

        // SET DEFAULT OPTIONS
        var splideDefaultOptions = {
          type: "loop",
          autoplay: false,
          interval: 6000,
          lazyLoad: "nearby",
          pauseOnHover: false,
          resetProgress: false,
          arrows: false,
          pagination: false,
          gap: 0,
          grid: false,
        };

        splide = new Splide(splideElement, splideDefaultOptions);

        // Add slider Autoplay toggle button
        addAutoplayToggleButton(splide);

        splide.on("autoplay:play", function () {
          hasAutoplay = true;
        });

        splide.on("mounted", function () {
          autoplay = splide.Components.Autoplay;

          // Pause the autoplay if the first slide has video
          if (hasFirstVideoSlide && hasAutoplay) {
            autoplay.pause();
            isAutoplayResumed = false;
            // console.log("%cAutoplay Paused", "color: red; background: yellow; font-size: 30px");
          }
        });

        splide.on("moved", function (newIndex, prevIndex, destIndex) {
          // Set the previous slide video from the beginning
          const prevSlide = splide.Components.Slides.getAt(prevIndex).slide;
          const video = prevSlide.querySelector("video");
          video && (video.currentTime = 0);

          // Resume slider autoplay on slide change
          if (hasAutoplay && autoplay.isPaused()) {
            autoplay.play();
            isAutoplayResumed = true;
          }
        });

        // Start the carousels
        splide.mount(window.splide.Extensions);

        return autoplay;
      }

      if (heroFirstSlideVideo) {
        // Initialize the slider
        initSlider(true);

        // Initialize the video JS
        const videoJs = new VideoJs({ selector: ".js-avvio-first-slide-hls-video" });
        // Start the slider autoplay on video load
        videoJs.init([
          {
            eventType: "onended",
            cb() {
              if (hasAutoplay && !isAutoplayResumed) {
                splide.go("+1");
                autoplay.play();
                isAutoplayResumed = true;

                // console.log(
                //   "%cAutoplay RESUMED",
                //   "color: green; background: yellow; font-size: 30px"
                // );
              }
            },
          },
        ]);
      } else {
        initSlider();
      }
    }
  }
} // is-initialized

/**
 * Initialize the script when the block is previewed within the editor
 * https://www.advancedcustomfields.com/resources/javascript-api/
 */
if (window.acf) {
  window.acf.addAction("render_block_preview/type=avvio-carousel", avvioSplideSliderInit);
  window.acf.addAction("render_block_preview/type=avvio-logos", avvioSplideSliderInit);
  window.acf.addAction("render_block_preview/type=avvio-testimonials", avvioSplideSliderInit);
  window.acf.addAction("render_block_preview/type=avvio-feature-panel", avvioSplideSliderInit);
  window.acf.addAction("render_block_preview/type=avvio-hero", avvioSplideSliderInit);
  window.acf.addAction("render_block_preview/type=avvio-instagram-feed", avvioSplideSliderInit);
} else {
  document.addEventListener("DOMContentLoaded", avvioSplideSliderInit);
}
